
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSnowShowersPolartwilight as ObiLightSnowShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-snow-showers-polartwilight.js';
 
 
 

 
 export const ObiLightSnowShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-light-snow-showers-polartwilight',
   elementClass: ObiLightSnowShowersPolartwilightElement,
   events: {
     
   }
  });
 
 